import {
  Alert,
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  MenuProps,
  Modal,
  Row,
  Select,
  Space,
  Statistic,
  Table,
  Tooltip,
  message,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  addMedicalStudio,
  editMasterPwd,
  editMedicalStudio,
  getMedStudios,
  getStudioMaster,
} from "../admin/utils";
import { MenuInfo } from "rc-menu/lib/interface";
import "../App.css";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import { emptyStudio, Studio } from "../studio/interfaces";
import { ColumnsType } from "antd/lib/table";
import { ALMSG_INTERNAL_ERR } from "../env";

import itIT from "antd/lib/locale/it_IT";
import "moment/locale/it";
import dayjs from "dayjs";
import { Doctor, instanceOfDoctor } from "../doctor/interfaces";
import TextArea from "antd/es/input/TextArea";
interface StudioRow extends Studio {
  key: number;
}

const AdminMSActionsMenu = ({
  studioId,
  enabled,
  showEditPwdModal,
}: {
  studioId: number;
  enabled: boolean;
  showEditPwdModal: Function;
}) => (
  <Menu
    onClick={(clickedValue: MenuInfo) => {
      if (clickedValue.key == "pwd") {
        showEditPwdModal(studioId);
      } else if (clickedValue.key == "del") {
        //TODO implement this
      }
    }}
    items={[
      {
        key: "pwd",
        label: "Password",
      },
      {
        key: "del",
        label: "Elimina",
      },
    ]}
  />
);

const EnableDisableModal = ({
  studio,
  visible,
  setVisible,
  setMsg,
}: {
  studio: Studio;
  visible: boolean;
  setVisible: Function;
  setMsg: Function;
}) => {
  const signedInAdmin: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [errMsg, setErrMsg] = useState("");
  const [form] = Form.useForm();
  const [selDate, setSelDate] = useState<Date>(
    studio.subscribedEnd ? new Date(studio.subscribedEnd) : new Date()
  );
  const [fbSizeMax, setFbSizeMax] = useState<number>(
    studio.fbSizeMax ? studio.fbSizeMax : 512
  );
const [subscriptionType, setSubscriptionType] = useState<string>("Free"
   
  );

  const enable =
    !studio.subscribedEnd || new Date() > new Date(studio.subscribedEnd);

  useEffect(() => {
    setSelDate(
      studio.subscribedEnd ? new Date(studio.subscribedEnd) : new Date()
    );
    
    setFbSizeMax(studio.fbSizeMax ? studio.fbSizeMax : 512);
    
  }, [studio]);

  //submit data
  const onFinish = () => {
    studio.subscribedEnd = selDate;
    studio.fbSizeMax = fbSizeMax;
    studio.subscriptionType = subscriptionType;
    editMedicalStudio(signedInAdmin.token, studio).then((response) => {
      setVisible(false);
      setMsg(response);
    });
  };
  return (
    <Modal
      title={"Licenza studio '" + studio.fullName + "'"}
      centered
      open={visible}
      footer={false}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      width={480}
    >
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        layout="vertical"
      >
        {errMsg && (
          <Form.Item>
            <Alert
              message={ALMSG_INTERNAL_ERR}
              description="Operazione non riuscita"
              type="error"
              showIcon
            />
          </Form.Item>
        )}
        <Row>
          <Col span={11}>
            <Form.Item label="Licenza">
              <Select
              value={studio.subscriptionType}
              onChange={(value) => setSubscriptionType(value as string)}
              >
              <Select.Option value="Lite">Lite</Select.Option>
              <Select.Option value="Business">Business</Select.Option>
              <Select.Option value="Professional">Professional</Select.Option>
              <Select.Option value="Exclusive">Exclusive</Select.Option>
              <Select.Option value="Ultra">Ultra</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Form.Item label="Email">
              <Input
                type="email"
                value={studio.email}
                onChange={(e) => (studio.email = e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Form.Item label="Numero di telefono">
              <Input
                type="tel"
                value={studio.telephone}
                onChange={(e) => (studio.telephone = e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Data">
              <Input
                type="date"
                value={selDate.toDateString()}
                style={{ display: "none" }}
              />
              <DatePicker
                locale={itIT.DatePicker}
                format={"DD/MM/YYYY"}
                value={dayjs(selDate)}
                onChange={(date) =>
                  setSelDate(date ? date.toDate() : new Date())
                }
              />
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Form.Item label="Spazio max (MB)">
              <Input
                type="number"
                value={fbSizeMax}
                onChange={(e) => setFbSizeMax(parseFloat(e.target.value))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item style={{ margin: "auto", textAlign: "right" }}>
          <Tooltip
            placement="top"
            title={enable ? "Sei sicuro di voler creare un nuovo account?" : ""}
          >
            <Button
              type="dashed"
              htmlType="submit"
              style={{
                background: "black",
                color: "white",
                margin: "2px",
              }}
            >
              CONFERMA
            </Button>
          </Tooltip>
          <Button type="primary" onClick={() => setVisible(false)}>
            ANNULLA
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export interface StudioAdd extends Studio {
  usernameMaster: string;
  emailMaster: string;
  passwordMaster: string;
  passwordMasterConfirmation: string;
  subscriptionType: string;
}

const AddMedicalStudioModal = ({
  visible,
  setVisible,
  setMsg,
}: {
  visible: boolean;
  setVisible: Function;
  setMsg: Function;
}) => {
  const signedInAdmin: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [errMsg, setErrMsg] = useState("");
  const [form] = Form.useForm();

  const [addStudio, setAddStudio] = useState<StudioAdd>({
    ...emptyStudio,
    logo: "example.png",
    usernameMaster: "",
    emailMaster: "",
    subscriptionType: "",
    passwordMaster: "",
    passwordMasterConfirmation: "",
  });

  //submit data
  const onFinish = () => {
    addMedicalStudio(signedInAdmin.token, addStudio).then((response) => {
      setVisible(false);
      setMsg(response);
    });
  };
  return (
    <Modal
      title={"Crea nuovo studio "}
      centered
      open={visible}
      footer={false}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      width={768}
    >
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        layout="vertical"
      >
        {errMsg && (
          <Form.Item>
            <Alert
              message={ALMSG_INTERNAL_ERR}
              description="Operazione non riuscita"
              type="error"
              showIcon
            />
          </Form.Item>
        )}
        <h3>Dati base studio</h3>
        <Row>
          <Col>
            <Form.Item label="Name login Studio">
              <Input
                type="text"
                onChange={(e) =>
                  setAddStudio({ ...addStudio, nameSignIn: e.target.value })
                }
              />
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Form.Item label="Nome Studio Completo">
              <Input
                type="text"
                onChange={(e) =>
                  setAddStudio({ ...addStudio, fullName: e.target.value })
                }
              />
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Form.Item label="P. IVA / CF">
              <Input
                type="text"
                onChange={(e) =>
                  setAddStudio({ ...addStudio, vat: e.target.value })
                }
              />
            </Form.Item>
          </Col>

          <Col span={11}>
            <Form.Item name="Licenza">
              
              <Select placeholder="Seleziona un'opzione"  onChange={(e) =>
                  setAddStudio({ ...addStudio, subscriptionType: e.target.value }) }>
               
              
              
                <Select.Option value="Lite">Lite</Select.Option>
                <Select.Option value="Business">Business</Select.Option>
                <Select.Option value="Professional">Professional</Select.Option>
                <Select.Option value="Exclusive">Exclusive</Select.Option>
                <Select.Option value="Ultra">Ultra</Select.Option>
             
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <h3>Dati studio DOTTORE master</h3>
        <Row>
          <Col>
            <Form.Item label="Login username">
              <Input
                type="text"
                onChange={(e) =>
                  setAddStudio({ ...addStudio, usernameMaster: e.target.value })
                }
              />
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Form.Item label="Email">
              <Input
                type="text"
                onChange={(e) =>
                  setAddStudio({ ...addStudio, emailMaster: e.target.value })
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Item label="Password">
              <Input
                type="text"
                onChange={(e) =>
                  setAddStudio({ ...addStudio, passwordMaster: e.target.value })
                }
              />
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Form.Item label="Conferma password">
              <Input
                type="text"
                onChange={(e) =>
                  setAddStudio({
                    ...addStudio,
                    passwordMasterConfirmation: e.target.value,
                  })
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item style={{ margin: "auto", textAlign: "right" }}>
          <Tooltip
            placement="top"
            title={
              "Attento!! Controlla se hanno versato prima 10k mila euro su IBAN di Devis prima di effettuare questa operazione"
            }
          >
            <Button
              type="dashed"
              htmlType="submit"
              style={{
                background: "black",
                color: "white",
                margin: "2px",
              }}
            >
              AGGIUNGI
            </Button>
          </Tooltip>
          <Button type="primary" onClick={() => setVisible(false)}>
            ANNULLA
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const EditMedicalStudioModal = ({
  studio,
  visible,
  setVisible,
  setMsg,
}: {
  studio: Studio;
  visible: boolean;
  setVisible: Function;
  setMsg: Function;
}) => {
  const signedInAdmin: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [master, setMaster] = useState<Doctor>();
  const [errMsg, setErrMsg] = useState("");
  const [pwd, setPwd] = useState("");
  const [pwdConfirmation, setPwdConfirmation] = useState("");
  const [form] = Form.useForm();

  useEffect(() => {
    setPwd("");
    setPwdConfirmation("");
    if (studio.id && studio.id >= 0)
      getStudioMaster(signedInAdmin.token, studio).then((response) => {
        if (instanceOfDoctor(response)) setMaster(response);
        else {
          setErrMsg(response);
          setVisible(false);
        }
      });
  }, [studio]);

  useEffect(() => {
    setPwd("");
    setPwdConfirmation("");
  }, [visible]);

  //submit data
  const onFinish = () => {
    if (master)
      editMasterPwd(signedInAdmin.token, {
        ...master,
        password: pwd,
        passwordConfirmation: pwdConfirmation,
      }).then((response) => {
        setVisible(false);
        setMsg(response);
      });
    else {
      setVisible(false);
      setMsg("Master not found");
    }
  };
  return (
    <Modal
      title={"Edit studio master info for " + studio.fullName}
      centered
      open={visible}
      footer={false}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      width={480}
    >
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        layout="vertical"
      >
        {errMsg && (
          <Form.Item>
            <Alert
              message={ALMSG_INTERNAL_ERR}
              description="Operazione non riuscita"
              type="error"
              showIcon
            />
          </Form.Item>
        )}
        <h3>Aggiorna password per {master?.username}</h3>
        <Row>
          <Col>
            <Form.Item label="Password">
              <Input
                type="text"
                value={pwd}
                onChange={(e) => {
                  setPwd(e.target.value);
                }}
              />
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Form.Item label="Conferma password">
              <Input
                type="text"
                value={pwdConfirmation}
                onChange={(e) => {
                  setPwdConfirmation(e.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item style={{ margin: "auto", textAlign: "right" }}>
          <Button
            className="ant-btn-ghost"
            type="dashed"
            htmlType="submit"
            style={{
              background: "black",
              color: "white",
              margin: "2px",
            }}
          >
            AGGIORNA
          </Button>
          <Button
            className="ant-btn-danger"
            type="primary"
            onClick={() => setVisible(false)}
          >
            ANNULLA
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const AdminHome = () => {
  const signedInAdmin: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [studios, setStudios] = useState<StudioRow[]>([]);
  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);
  const [msg, setMsg] = useState("");
  // Enable/disable medical studio
  const [selMStudio, setSelMStudio] = useState<Studio>(emptyStudio);
  const [enDisStudioVisible, setEnDisMStudioVisible] = useState<boolean>(false);

  // Add new medical studio
  const [addStudioVisible, setAddMStudioVisible] = useState<boolean>(false);

  const [addDoctorVisible, setAddMDoctorVisible] = useState<boolean>(false);

  // Edit studio master pwd medical studio
  const [editStudioMasterVisible, setEditStudioMasterVisible] =
    useState<boolean>(false);

  const openEnDisModal: Function = (studioId: number) => {
    // console.log("selected " + studioId);
    const filtered = studios.filter((s) => s.id == studioId);

    //console.log("found ", filtered[0]);
    if (filtered.length == 1) {
      setSelMStudio(filtered[0]);
      setEnDisMStudioVisible(true); //En dis ms has been selected
    }
  };

  const openEditPwdModal: Function = (studioId: number) => {
    // console.log("selected " + studioId);
    const filtered = studios.filter((s) => s.id == studioId);

    //console.log("found ", filtered[0]);
    if (filtered.length == 1) {
      setSelMStudio(filtered[0]);
      setEditStudioMasterVisible(true); //Edit pwd ms has been selected
    }
  };

  //s
  //useEffect(() => {}, [selMStudio]);

  const columns: ColumnsType<StudioRow> = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      sorter: {
        compare: (a, b) => a.key - b.key,
        multiple: 1, // Consentire solo l'ordinamento ascendente e discendente
      },
      defaultSortOrder: "descend", // Imposta l'ordinamento discendente di default
    },
    {
      title: "Nome",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Nome login",
      dataIndex: "nameSignIn",
      key: "nameSignIn",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Telefono",
      dataIndex: "telephone",
      key: "telephone",
    },
    {
      title: "VAT",
      dataIndex: "vat",
      key: "vat",
    },
    {
      title: "Creato il",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text: string) => (
        <>
          {text != undefined ? new Date("" + text).toLocaleDateString() : "-"}
        </>
      ),
    },
    {
      title: "Aggiornato il",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text: string) => (
        <>
          {text != undefined ? new Date("" + text).toLocaleDateString() : "-"}
        </>
      ),
    },
    {
      title: "Iscrizione termina il",
      dataIndex: "subscribedEnd",
      key: "subscribedEnd",
      sorter: (a, b) => {
        const dateA = a.subscribedEnd ? new Date(a.subscribedEnd).getTime() : 0;
        const dateB = b.subscribedEnd ? new Date(b.subscribedEnd).getTime() : 0;
        return dateA - dateB;
      },
      render: (text: string) => {
  const endDate = new Date("" + text);
  const currentDate = new Date();
  const diffTime = endDate.getTime() - currentDate.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

 


  let backgroundColor = "white";
  if (diffDays < 0) {
    backgroundColor = "#ff000054";
  } else if (diffDays <= 30) {
    backgroundColor = "#ffa6007c";
  } else if (diffDays > 30) {
    backgroundColor = "#00a1006e";
  }

  return (
    <div style={{ backgroundColor }}>
      {text != undefined ? endDate.toLocaleDateString() : "-"}
    </div>
  );
      },
    },
    {
      title: "Licenza",
      dataIndex: "subscriptionType",
      key: "subscriptionType",
    },

    {
      title: "Firebase",
      dataIndex: "fbSize",
      key: "fbSize",
      render: (text: string) => <>{text != undefined ? text + "MB" : "-"}</>,
    },
    {
      title: "MAX",
      dataIndex: "fbSizeMax",
      key: "fbSizeMax",
      render: (text: string) => <>{text != undefined ? text + "MB" : "-"}</>,
    },
    {
      title: "Limite Memoria",
      key: "actions",
      render: (_: any, record: any) => {
        const fbSize = parseFloat(record.fbSize);
        const fbSizeMax = parseFloat(record.fbSizeMax);
        const difference = fbSizeMax - fbSize;

        // Mostra il pulsante solo se la differenza è inferiore a 30
        return difference < 30 ? (
          <Button
            onClick={() => (
              (window.location.href = `tel:${record.telephone}`),
              console.log("Number: " + record.telephone)
            )}
          >
            Chiama
          </Button>
        ) : null;
      },
      sorter: (a: any, b: any) => {
        const diffA = parseFloat(a.fbSizeMax) - parseFloat(a.fbSize);
        const diffB = parseFloat(b.fbSizeMax) - parseFloat(b.fbSize);

        return (diffA < 30 ? 1 : 0) - (diffB < 30 ? 1 : 0);
      },
      defaultSortOrder: "ascend",
    },
    {
      title: "Azione",
      key: "action",
      render: (_, record) => (
        <Dropdown.Button
          overlay={
            <AdminMSActionsMenu
              showEditPwdModal={(id: number) => openEditPwdModal(id)}
              studioId={record.id ? record.id : -1}
              enabled={
                record.subscribedEnd
                  ? new Date() < new Date(record.subscribedEnd)
                  : false
              }
            />
          }
          onClick={() => openEnDisModal(record.id)}
        >
          Gestisci
        </Dropdown.Button>
      ),
    },
  ];

  const [StudioX, setStudioX] = useState<number | undefined>(undefined);
  
  const [StudioX3, setStudioX3] = useState<number | undefined>(undefined);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    getMedStudios(signedInAdmin.token).then(async (medStudios) => {
      const filteredStudios = medStudios.filter((studio) =>
        studio.fullName.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setStudios(
        filteredStudios.map((ms, i) => ({ ...ms, key: ms.id ? ms.id : -i }))
      );
    });
  }, [signedInAdmin, searchTerm]);

  useEffect(() => {
    getMedStudios(signedInAdmin.token).then(async (medStudios) => {
      // Questo imposta TUTTI i medStudios
      setStudios(
        medStudios.map((ms, i) => ({ ...ms, key: ms.id ? ms.id : -i }))
      );

      // Qui calcoli i TOT attivi senza sovrascrivere di nuovo setStudios
      const activeStudios = medStudios.filter(
        (studio) => studio.subscribedEnd && new Date(studio.subscribedEnd) > new Date()
      );
      const totalStudio = activeStudios.length;
      //console.log(`Numero totale di studi attivi: ${totalStudio}`);
      setStudioX(totalStudio);

      const totalStudio3 = medStudios.length;
      //console.log(`Numero totale di studi presenti: ${totalStudio3}`);
      setStudioX3(totalStudio3);
    });

    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    return () => window.removeEventListener("resize", handleResize);
}, [signedInAdmin]);

 

  return (
    <>
      <div className="centered">
        <Row>
          <h3 className="section-title">Bentornato ADMIN</h3>
          <Statistic
            className="thecirclex"
            title="Totale Studi Attivi"
            value={StudioX}
          />
         
          <Col span={10}>
            <Input
              className="gig"
              placeholder="Cerca per nome studio"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Col>
          <Col span={3}>
          <Statistic
            className="thecirclex"
            title="Totale Studi"
            value={StudioX3}
          />
          </Col>
          <Button
            className="add-studio"
            onClick={() => setAddMStudioVisible(!addStudioVisible)}
          >
            Aggiungi Studio
          </Button>
        </Row>
      </div>
      <Row>
        <Col span={23}>
          <Table
            dataSource={studios}
            columns={columns}
            className="exam-table"
            pagination={{ pageSize: 10 }}
          />
        </Col>
      </Row>
      <div className="centered">
        <Button onClick={() => setAddMStudioVisible(!addStudioVisible)}>
          Aggiungi Studio
        </Button>
      </div>
      {msg != "" && (
        <Alert type={msg == "ok" ? "success" : "error"} message={msg} />
      )}
      <EnableDisableModal
        studio={selMStudio}
        visible={enDisStudioVisible}
        setVisible={setEnDisMStudioVisible}
        setMsg={setMsg}
      />
      <AddMedicalStudioModal
        visible={addStudioVisible}
        setVisible={setAddMStudioVisible}
        setMsg={setMsg}
      />
      <EditMedicalStudioModal
        studio={selMStudio}
        visible={editStudioMasterVisible}
        setVisible={setEditStudioMasterVisible}
        setMsg={setMsg}
      />
    </>
  );
};

export default AdminHome;
function delay(arg0: number) {
  throw new Error("Function not implemented.");
}
